<div
  class="typo-h8-light sticky left-0 top-0 z-[800] flex w-[48px] flex-1 items-center justify-center bg-text-white pb-[15px]">
  <span
    class="relative flex w-full items-center justify-center rounded-xl bg-background-light-grey py-0.5 text-text-primary">
    {{ 'schedule_calendar_my_day' | translate }}
  </span>
</div>

@for (appointment of myDay; track appointment.id) {
<lib-schedule-calendar-item #myDayCalendarItem class="cursor-pointer" [style.outlineColor]="appointment.color"
  [ngClass]="{
      'shadow-card outline outline-1': appointment.id === selectedAppointmentId,
      'col-span-2': !elementHasParallelAppointments(appointment)
    }" (click)="onCalendarItemClick(appointment.id)" [style.gridRowStart]="appointment.from | scheduleTimeToGridRow"
  [style.gridRowEnd]="appointment.to | scheduleTimeToGridRow" [vm]="appointment" [isMyDay]="true"
  [isShowcase]="isShowcase" [ffdPushTagOnClick]="{
      event: TagEvent.ScheduleAppointmentDetailsOpened
    }" />
}
